
export function subMarkerContentForExperience(experience) {
    const thumbnail = experience.has_benefits ? renderThumbnail(experience.thumbnail_url, experience.thumbnail_aspect) : '';
    return `

    ${ thumbnail }
    <div class="submarker__info">
        ${ renderPrimaryName(experience.primary_name) }
        ${ renderSecondaryName(experience.secondary_name) }
        ${ renderMarkerIcons(experience.submarker_icons) }
    </div>
    ${ renderDetailsLink(experience.url) }

    `;
}

function renderThumbnail(url, aspect_ratio=1) {
    if (!url) { return '' }
    const width = 280; // should match the value specified in the .submarker CSS.
    const height = width / aspect_ratio;
    return `

<div class="submarker__thumb" style="background-image: url('${ url }')">
    <img src="${ url }" width="${width}" height="${height}">
</div>

    `;
}

function renderPrimaryName(name) {
    if (!name) { return '' }
    return `

<h3 class="submarker__primary_name">${ name }</h3>

    `;
}

function renderSecondaryName(name) {
    if (!name) { return '' }
    return `

<h4 class="submarker__secondary_name">${ name }</h4>

    `;
}

function renderMarkerIcons(markerIcons) {
    if (!markerIcons) { return '' }
    return `

<div class="submarker__marker_icons">
    <table>
        ${ markerIcons.map( markerIcon => renderMarkerIcon(markerIcon) ).join('') }
    </table>
</div>

    `;
}

function renderMarkerIcon(markerIcon) {
    if (!markerIcon) { return '' }

    const icon_url = markerIcon['icon_url'];
    const name = markerIcon['name'];
    return `

<tr class="submarker__marker_icons__marker_icon marker_icon">
    <td class="marker_icon__icon">
        <img src="${ icon_url }"/>
        ${ renderMarkerIconName(name) }
    </td>
</tr>

    `;
}

function renderMarkerIconName(name) {
    if (!name) { return '' }

    const delimiter = ':';
    const nameComponents = name.split(delimiter);
    const nameHtml = (nameComponents.length > 1) ? `<span>${ nameComponents[0] }:</span> ${ nameComponents[1] }` : nameComponents[0];
    return `

<td class="marker_icon__name">
    ${ nameHtml }
</td>

    `;
}

function renderDetailsLink(url) {
    if (!url) { return '' }
    return `

<div>
    <p class="submarker__details_link">
        <a href="${ url }">Details</a>
    </p>
</div>

    `;
}

